/**
 * @type {{API_ENDPOINT: string}}
 */
export const applicationSettings = {
  API_ENDPOINT: process.env.API_URL,
  SSO_URL: process.env.SSO_URL,
  SHOW_SIGN_UP: JSON.parse(process.env.SHOW_SIGN_UP.toLowerCase()) || false,
};
